import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { FloatButton, Modal } from 'ant-design-vue';
import { createVNode, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { DeleteFilled } from '@ant-design/icons-vue';
import { Hitomi } from '@/model/hitomi';
import HitomiGallery from '@/components/disposable/HitomiGallery.vue';
import HitomiGallerySkeleton from '@/components/disposable/HitomiGallerySkeleton.vue';
import HitomiView from '@/components/disposable/HitomiView.vue';
import HitomiViewSkeleton from '@/components/disposable/HitomiViewSkeleton.vue';
import { deleteHitomi, favoriteHitomi, getHitomiDetail } from '@/repository/hitomi';


export default /*#__PURE__*/_defineComponent({
  __name: 'HitomiInformationView',
  setup(__props) {

const { params } = useRoute();
const { push } = useRouter();
const store = useStore();

const hitomiUUID = params.hitomiUUID as string;
const isLoadingContent = ref(true);
const isLoadingGallery = ref(true);
const hitomi = ref<Hitomi>();

onMounted(async () => {
	isLoadingContent.value = true;
	await fetchData();
	isLoadingContent.value = false;
});

async function fetchData() {
	try {
		hitomi.value = await getHitomiDetail(hitomiUUID);
		document.title = `${hitomi.value?.hitomiTitle} - Hitomi | Unikume Kinkando`;
	} catch (error) {
		push(`/hitomi`);
	}
}

async function remove() {
	Modal.confirm({
		title: 'Delete Doujin',
		icon: createVNode(DeleteFilled),
		content: 'Do you want to delete this hitomi right?',
		okText: 'Yes',
		cancelText: 'No',
		async onOk() {
			if (hitomi.value?.hitomiUUID) {
				await deleteHitomi(hitomi.value.hitomiUUID);
				store.dispatch('alert', { type: 'success', message: 'Delete hitomi successfully!' });
				push(`/hitomi`);
			}
		}
	});
}

async function favorite() {
	if (!hitomi.value) {
		return;
	}
	try {
		hitomi.value = { ...hitomi.value, isFavorite: !hitomi.value.isFavorite };
		await favoriteHitomi(hitomi.value.hitomiUUID as string, !!hitomi.value.isFavorite);
	} catch (error) {
		hitomi.value = { ...hitomi.value, isFavorite: !hitomi.value.isFavorite };
		store.dispatch('alert', { type: 'error', message: 'something went wrong, please try again!' });
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(FloatButton).BackTop),
    (isLoadingContent.value || !hitomi.value)
      ? (_openBlock(), _createBlock(HitomiViewSkeleton, { key: 0 }))
      : _createCommentVNode("", true),
    (hitomi.value)
      ? (_openBlock(), _createBlock(HitomiView, {
          key: 1,
          hitomi: hitomi.value,
          onDelete: remove,
          onFavorite: favorite
        }, null, 8, ["hitomi"]))
      : _createCommentVNode("", true),
    (isLoadingGallery.value || !hitomi.value)
      ? (_openBlock(), _createBlock(HitomiGallerySkeleton, { key: 2 }))
      : _createCommentVNode("", true),
    (hitomi.value)
      ? (_openBlock(), _createBlock(HitomiGallery, {
          key: 3,
          hitomi: hitomi.value,
          onLoaded: _cache[0] || (_cache[0] = () => (isLoadingGallery.value = false))
        }, null, 8, ["hitomi"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})